import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

// Internacionalización desde el día uno (Constitución §16).
// No hardcoded UI strings — everything via translation keys.
//
// VLT-297 (fix estructural BACKEND_READINESS §6) fase 2 (12-sep): NINGÚN
// catálogo viaja en el bundle de entrada — inglés y español llegan como
// chunks diferidos (el inglés se carga SIEMPRE porque es el fallback; en
// español se cargan ambos, igual que antes). main.tsx espera i18nReady antes
// de pintar, así jamás se ve un destello sin traducciones.

const stored = localStorage.getItem('vaultex.lang') ?? 'en';

void i18n.use(initReactI18next).init({
  resources: {},
  // Inglés por defecto (decisión del propietario 2026-07-17); la elección del
  // usuario se recuerda entre visitas.
  lng: stored,
  fallbackLng: 'en',
  interpolation: { escapeValue: false },
});

const loaded: Record<string, boolean> = {};
const ensureCatalog = async (lang: 'en' | 'es') => {
  if (loaded[lang]) return;
  const mod = lang === 'es' ? await import('./locales/es.json') : await import('./locales/en.json');
  i18n.addResourceBundle(lang, 'translation', mod.default, true, false);
  loaded[lang] = true;
};

/** Cambia el idioma cargando su catálogo si aún no está, y lo persiste. */
export const setLanguage = async (lang: 'es' | 'en') => {
  localStorage.setItem('vaultex.lang', lang);
  await ensureCatalog(lang);
  await i18n.changeLanguage(lang);
};

/** Resuelta cuando el idioma guardado tiene su catálogo listo (arranque).
 *  El inglés se carga siempre: es el fallback de las claves faltantes. */
// 2-nov (react-best-practices, async-parallel): los dos catálogos se piden a
// la vez; antes el español esperaba a que terminara el inglés.
// <html lang> sigue al idioma activo (lectores de pantalla y traductor).
const syncLang = (lng: string) => {
  if (typeof document !== 'undefined') document.documentElement.lang = lng.startsWith('es') ? 'es' : 'en';
};
i18n.on('languageChanged', syncLang);

export const i18nReady: Promise<void> = (async () => {
  await Promise.all([ensureCatalog('en'), stored.startsWith('es') ? ensureCatalog('es') : null]);
  // Con el catálogo ya presente, re-emite el cambio para que todo re-renderice.
  await i18n.changeLanguage(stored);
})();

export default i18n;
